import {Action, getModule, Module, Mutation, VuexModule} from "@/node_modules/vuex-module-decorators";
import store from "@/classes/core/store";
import ManagerApi from "@/classes/app/api/manager-api";
import {appAuthModule} from "@/store/app/auth";
import {$v} from "@/classes/utils/var-util";
import {$apm} from "@/classes/app/app-manager";

export interface IShopMenuCategory {
    id: number;
    toid: string;
    title: string;
    path: string;
    is_active: boolean;
    is_reservation: boolean;
    reserve_shop: string;
    published_at: string;
    created_at: string;
    updated_at: string;
}

export interface IShopMenuCategoryFilter {
    type?: string;
    status?: number;
    word?: string;
    date?: string;
}

export interface IManagerShopMenuCategoryModule {
    fetched: boolean;
    filter: any;
    page: number;
    info: any;
    records: IShopMenuCategory[];
}

@Module({dynamic: true, store, name: 'managerShopMenuCategory', namespaced: true})
class Store extends VuexModule implements IManagerShopMenuCategoryModule {

    public fetched: boolean = false;
    public filter: any = {
        type: 'blog',
        word: '',
        status: null,
        date: '',
    };
    public page: number = 1;
    public info: any;
    public records: IShopMenuCategory[] = [];

    @Mutation
    public updateRecords(value: IShopMenuCategory[]) {
        this.records = value;
    }

    @Mutation
    public updateFilter(filter: IShopMenuCategoryFilter) {
        this.filter = Object.assign({}, M.filter, filter);
    }

    @Mutation
    public updateArticle(value: IShopMenuCategory) {
        this.records = Array.from(this.records).map((_: IShopMenuCategory) => {
            return (_.toid === value.toid) ?
                Object.assign({}, _, value) : _;
        });
    }

    @Mutation
    public updateFetched(fetched: boolean) {
        this.fetched = fetched;
    }

    @Action
    public async resetFilter() {
        M.updateFilter({
            status: 0,
            word: '',
            date: '',
        });
    }

    @Action
    public async fetch(param: {
        force?: boolean,
        path?: string,
        children?: boolean,
    } = {}): Promise<any> {

        if (!!$v.path(param, 'force') && M.fetched) {
            return;
        }

        try {
            const records = await ManagerApi.ShopMenuCategory.get(Object.assign({
                site: $apm.siteid,
                path: $v.path(param, 'depth'),
                children: $v.path(param, 'children'),
            }, M.filter)).execAsync('records.list');

            M.updateRecords(records || []);
            M.updateFetched(true);

            return null;
        } catch (e) {
            return e;
        }
    }

    @Action
    public async save(record: any): Promise<any> {

        // console.log('save() > ', record);
        try {
            const api = (!!$v.path(record, 'toid')) ?
                ManagerApi.ShopMenuCategory.put(record.toid, record)
                : ManagerApi.ShopMenuCategory.post(record);

            return await api.execAsync('record');
        } catch (e) {
            console.error(e);
            return e;
        }
    }
}

export const managerShopMenuCategoryModule = getModule(Store);

const M = managerShopMenuCategoryModule;

